import { SvgProps } from '../SvgRendererTypes';

export const FireWatchIcon = ({ fillColor, ...props }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Fire Watch Icon</title>
      <path
        fill={fillColor}
        d="M21.71 19.46L18.45 16.2C19.43 14.74 20.01 12.99 20.01 11.09C20.01 6.07 15.98 2 11.01 2C6.04 2 2 6.07 2 11.09C2 16.11 6.03 20.18 11 20.18C12.95 20.18 14.76 19.54 16.23 18.48L19.46 21.71C19.66 21.91 19.91 22 20.17 22C20.43 22 20.68 21.9 20.88 21.71L21.71 20.88C22.1 20.49 22.1 19.85 21.71 19.46ZM11 19.18C6.59 19.18 3 15.55 3 11.09C3 6.63 6.59 3 11 3C15.41 3 19 6.63 19 11.09C19 14.98 15.78 19.18 11 19.18ZM17.02 17.84L17.04 17.82C17.24 17.64 17.43 17.44 17.62 17.24L17.85 17.01L18.68 17.84L17.85 18.67L17.02 17.84ZM20.17 21L18.56 19.39L19.39 18.56L21 20.17L20.17 21Z"
      />
      <path
        fill={fillColor}
        d="M12.26 6.26C12.25 6.26 13.19 9.35 12.26 9.35C11.48 9.35 11.37 5.25 7.92 5.01C7.92 5.01 8.8 7.68 7.92 8.73C6.71 10.19 6.06 11.21 6.06 12.76C6.06 15.37 8.14 17.41 10.73 17.41C13.32 17.41 15.98 15.67 15.98 11.83C15.98 8.57 13.39 6.26 12.26 6.26ZM10.73 16.41C8.67 16.41 7.06 14.81 7.06 12.76C7.06 11.53 7.56 10.72 8.69 9.37C9.31 8.62 9.37 7.5 9.27 6.53C9.9 7.03 10.28 7.82 10.65 8.71C10.99 9.52 11.34 10.35 12.26 10.35C12.68 10.35 13.06 10.16 13.32 9.83C13.53 9.56 13.71 9.15 13.66 8.31C14.34 9.11 14.98 10.32 14.98 11.83C14.98 14.97 12.78 16.41 10.73 16.41Z"
      />
    </svg>
  );
};
